import React from 'react';
import debounce from 'debounce';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Button, Card, Cascader, Col, Form, Input, message, Modal, Row, Select, Table, Tag, Popconfirm } from 'antd';

import BrandAutocomplete from '../../brands/brand-autocomplete';
import SupplierAutocomplete from '../../supplier/autocomplete';

import {
	_getAllCategories,
	_getMassUploadBatch,

	_postDeleteProducts,
	_postDownloadCsvForGoogle,
	_postSearchProducts,
	_postTransferProducts
} from '../../../services';

import { formatStringToKebabCase } from '../../../utils/string';
import './index.css';

const Option = Select.Option;

let defaultState = {

	keywords: [],

	limit: 300,
	loading: false,
	// cfm
	confirmModalOpen: false,

	fromCategory: [],
	categories: [],
	fromProducts: [],

	query: {},

	// to 
	toType: '',
	to: {
		unit: '',
		value: ''
	},
	selectedProducts: []

};

class TransferProducts extends React.Component {

	render() {

		const columns = [
			{
				title: '#', width: 50, key: 'index', render: (text, record, index) => {
					return index + 1;
				}
			},
			{
				title: 'Image', width: 100, key: 'image', render: (text, record, index) => {

					let image = "https://eezee.sg/static/eezee-product.svg";

					if (record.images && record.images.length > 0) {
						image = record.images[0].url;
					}

					return (
						<Row
							type="flex"
							justify="center"
							align="middle"
							style={{ height: 50 }}>
							<Col>
								<img style={{ maxHeight: 50, maxWidth: 50 }} src={image} alt="product" />
							</Col>
						</Row>
					);
				}
			},
			{
				title: 'Title', dataIndex: 'title', render: (text, record, index) => {

					return (
						<span>
							<Tag color={record.active ? "green" : "red"}>Active</Tag>
							{` ${text}`}
						</span>
					);

				}
			},
			{
				title: 'Approved',
				dataIndex: 'approved',
				render: (approved) => this.renderTag(approved),
				onFilter: (value, record) => record.approved == value,
				filters: [
					{ text: 'True', value: true },
					{ text: 'False', value: false },
				]

			},
			{ title: 'Model', dataIndex: 'model' },
			{ title: 'Category', dataIndex: 'categories.sub' },
			{ title: 'Enquiry Type', dataIndex: 'enquiryType' },
			{
				title: 'Brand', dataIndex: 'brand.name', render: (text, record, index) => {

					if (text && text.length > 0) return text;
					return record.supplierBrand || "";

				}
			}
		];

		const showBrandAutoComplete = () => {

			if (this.state.query['brand.name'] === null) {
				return false;
			}

			if (this.state.query['brand.name'] && this.state.query['brand.name'].$ne === null) {
				return false;
			}

			return true;
		};

		const showCascader = () => {

			// if( !this.state.query['categories.subKebabCase'] ){
			// 	return true;
			// }

			if (this.state.query['categories.subKebabCase'] === "") {
				return false;
			}

			if (this.state.query['categories.subKebabCase'] && this.state.query['categories.subKebabCase'].$ne === "") {
				return false;
			}

			return true;
			// ! || (
			// 	this.state.query['categories.subKebabCase'] !== "" && 
			// 	this.state.query['categories.subKebabCase'] && this.state.query['categories.subKebabCase'].$ne !== ""
			// ) && 
		};

		return (
			<div>
				{this.state.massUploadId && (
					<Row>
						<Card>
							<h2>{(this.state.massUploadBatch && this.state.massUploadBatch.user.details.companyName) || "Loading..."}</h2>
							<p>Mass Transfer Id: {this.state.massUploadId}</p>
							<p>Mass Upload Date: {this.state.massUploadBatch && moment(this.state.massUploadBatch.dateCreated).format("LLLL")}</p>
						</Card>
					</Row>
				)}

				<Row style={{ padding: 16 }} type="flex" gutter={16}>
					<Col>
						<Card title="Transfer From">


							<Form>
								{/* <Form.Item>
									<Select 
										style={{ width: 300 }} 
										onChange={this.handleOnChangeFrom}>

										<Option value="CATEGORY">From Category</Option>
										<Option value="BRAND">From Brand</Option>
										<Option value="CONTAINING_TERM">Containing Term</Option>

									</Select>
								</Form.Item> */}

								<Form.Item>
									<Row type="flex" gutter={8}>

										{
											showCascader() && (
												<Col>
													<Cascader
														popupClassName="long-cascader-container"
														options={this.state.categories}
														showSearch={{
															filter(inputValue, path) {
																const trimmedInput = inputValue.toLowerCase().trim();
																const formattedInput = formatStringToKebabCase(trimmedInput);
																return path.filter(option => option.value.toLowerCase().indexOf(formattedInput) > -1).length > 0;
															}
														}}
														onChange={(value) => {
															this.handleSelectFrom({ unit: 'category', value });
														}} />
												</Col>
											)
										}

										<Col>
											<Button
												type={this.state.query['categories.subKebabCase'] === "" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'category', value: "" })}>
												No Category
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['categories.subKebabCase'] && this.state.query['categories.subKebabCase'].$ne === "" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'category', value: { $ne: "" } })}>
												Has Category
											</Button>
										</Col>

										{
											(this.state.query['categories.subKebabCase'] || (this.state.query['categories.subKebabCase'] === "")) && (
												<Col>
													<Button
														onClick={(value) => this.removeFromQuery({ unit: 'category' })}>
														Cancel
													</Button>
												</Col>
											)
										}
									</Row>
								</Form.Item>

								<Form.Item>
									<Row type="flex" gutter={8}>

										{
											showBrandAutoComplete() && (
												<Col>

													<BrandAutocomplete
														onSelect={(value) => this.handleSelectFrom({ unit: 'brand', value })} />

												</Col>
											)
										}

										<Col>
											<Button
												type={this.state.query['brand.name'] === null ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'brand', value: null })}>
												No Brand
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['brand.name'] && this.state.query['brand.name'].$ne === null ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'brand', value: { $ne: null } })}>
												Has Brand
											</Button>
										</Col>

										<Col>
											{
												(this.state.query['brand.name'] || this.state.query['brand.name'] === null) && (
													<Button
														onClick={(value) => this.removeFromQuery({ unit: 'brand' })}>
														Cancel
													</Button>
												)
											}
										</Col>
									</Row>
								</Form.Item>

								<Form.Item>
									<Row type="flex" gutter={8}>

										<Col>
											<SupplierAutocomplete
												onSelect={(value) => {
													const [supplierId] = value.split('~!@');
													this.handleSelectFrom({ unit: 'supplierId', value: supplierId });
												}} />
										</Col>

										<Col>
											<Button
												type={this.state.query['supplierId'] === null ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'supplierId', value: null })}>
												No Supplier
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['supplierId'] && this.state.query['supplierId'].$ne === null ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'supplierId', value: { $ne: null } })}>
												Has Supplier
											</Button>
										</Col>

										<Col>
											{
												this.state.query['supplierId'] && (
													<Button
														onClick={(value) => this.removeFromQuery({ unit: 'supplierId' })}>
														Cancel
													</Button>
												)
											}
										</Col>
									</Row>

									{/* <Input 	
									placeholder="Search Supplier"
									style={{ width: 200 }} 
									value={ this.state.query.title }
									onChange={ ( e ) => this.handleSelectFrom({ unit: 'search', value: e.target.value }) }
									/> */}
								</Form.Item>

								<Form.Item>
									<Row type="flex" gutter={8}>
										<Col>
											<Select
												style={{ width: 200 }}
												onChange={(e) => {
													this.handleSelectFrom({ unit: "baseCurrency", value: e });
												}}
												value={this.state.query.baseCurrency}>
												<Option value="SGD">SGD</Option>
												<Option value="MYR">MYR</Option>
												<Option value="IDR">IDR</Option>
												<Option value="PHP">PHP</Option>
												<Option value="THB">THB</Option>
											</Select>
										</Col>
									</Row>
								</Form.Item>

								<Form.Item>
									<Row type="flex" gutter={8}>

										<Col>
											<Button
												type={this.state.query['active'] && !this.state.query['active'].$ne ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'active', value: true })}>
												Active
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['active'] && this.state.query['active'].$ne === true ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'active', value: { $ne: true } })}>
												Inactive
											</Button>
										</Col>

										<Col>
											{
												(this.state.query['active'] || this.state.query['active'] === null) && (
													<Button
														onClick={(value) => this.removeFromQuery({ unit: 'active' })}>
														Cancel
													</Button>
												)
											}
										</Col>
									</Row>
								</Form.Item>

								<Form.Item>
									<Row type="flex" gutter={8}>

										<Col>
											<Button
												type={this.state.query['enquiryType'] && this.state.query['enquiryType'] === "enquiry_only_with_price" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'enquiryType', value: "enquiry_only_with_price" })}>
												Enquiry
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['enquiryType'] && this.state.query['enquiryType'] === "enquiry_only_without_price" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'enquiryType', value: "enquiry_only_without_price" })}>
												Enquiry W/O Price
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['enquiryType'] && this.state.query['enquiryType'] === "add_to_cart_only" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'enquiryType', value: "add_to_cart_only" })}>
												Add To Cart
											</Button>
										</Col>

										<Col>
											<Button
												type={this.state.query['enquiryType'] && this.state.query['enquiryType'] === "both" ? "primary" : ""}
												onClick={() => this.handleSelectFrom({ unit: 'enquiryType', value: "both" })}>
												Enquiry & Add To Cart
											</Button>
										</Col>

										<Col>
											{
												(this.state.query['enquiryType'] || this.state.query['enquiryType'] === null) && (
													<Button
														onClick={(value) => this.removeFromQuery({ unit: 'enquiryType' })}>
														Cancel
													</Button>
												)
											}
										</Col>
									</Row>
								</Form.Item>

								<Form.Item>
									<Input
										placeholder="Search Title"
										style={{ width: 200 }}
										value={this.state.query.title}
										onChange={(e) => this.handleSelectFrom({ unit: 'search', value: e.target.value })}
									/>
								</Form.Item>

								{
									this.state.massUploadId && (
										<Form.Item>
											<Input
												placeholder="Search Supplier Brand"
												style={{ width: 200 }}
												value={this.state.query.supplierBrand}
												onChange={(e) => this.handleSelectFrom({ unit: 'supplierBrand', value: e.target.value })}
											/>
										</Form.Item>
									)
								}




							</Form>

						</Card>
					</Col>

					<Col>
						<Card title="Action">


							<Form>
								<Form.Item>
									<Select
										style={{ width: 200 }}
										onChange={this.handleOnChangeToType}
										value={this.state.toType}>

										<Option value="CATEGORY">Transfer To Category</Option>
										<Option value="BRAND">Transfer To Brand</Option>
										<Option value="SUPPLIER">Transfer To Supplier</Option>

										<Option value="ACTIVATE">Activate</Option>
										<Option value="DEACTIVATE">De-activate</Option>

										<Option value="ENQUIRY_TYPE">Transfer Enquiry Type</Option>


									</Select>
								</Form.Item>

								{
									this.state.toType === "CATEGORY" && (
										<Form.Item>
											<Cascader
												popupClassName="long-cascader-container"
												options={this.state.categories}
												showSearch={{
													filter(inputValue, path) {
														const trimmedInput = inputValue.toLowerCase().trim();
														const formattedInput = formatStringToKebabCase(trimmedInput);
														return path.filter(option => option.value.toLowerCase().indexOf(formattedInput) > -1).length > 0;
													}
												}}
												onChange={(value) => {
													this.handleSelectTo({ unit: 'category', value, label: value });
												}} />
										</Form.Item>

									)
								}

								{
									this.state.toType === "BRAND" && (
										<Form.Item>
											<BrandAutocomplete
												onSelect={(value) => this.handleSelectTo({ unit: 'brand', value: [value], label: [value] })} />
										</Form.Item>

									)
								}

								{
									this.state.toType === "SUPPLIER" && (
										<Form.Item>
											<SupplierAutocomplete
												onSelect={(value) => {
													const [supplierId, companyName] = value.split('~!@');
													this.handleSelectTo({ unit: 'supplier', value: [supplierId], label: [companyName] });
												}} />
										</Form.Item>

									)
								}

								{
									this.state.toType === "ENQUIRY_TYPE" && (
										<Form.Item>
											<Select
												style={{ width: '100%' }}
												onChange={(e) => this.handleSelectTo({ unit: "enquiryType", value: [e] })}
											>
												{Object.entries({
													enquiry_only_with_price: "Enquiry Only With Price",
													enquiry_only_without_price: "Enquiry Only Without Price",
													add_to_cart_only: "Add To Cart Only",
													both: "Both Enquiry and Add To Cart"
												}).map(([key, value]) => {
													return <Select.Option value={key} key={key}>{value}</Select.Option>;
												})}
											</Select>
										</Form.Item>

									)
								}

								<Form.Item>
									<Row gutter={8} type="flex" justify="end">
										<Col>
											<Popconfirm
												title="Are you sure you want to delete? This action can't be reversed! Your email will be logged!"
												onConfirm={this.handleDeleteProducts}>
												<Button type="danger">Delete</Button>
											</Popconfirm>
										</Col>
										<Col>
											<Button onClick={() => this.toggleModalVisible(true)}>
												Confirm
											</Button>
										</Col>
									</Row>
								</Form.Item>
							</Form>


						</Card>
					</Col>

					<Col>

						{/* <Button onClick={ this.handleDownloadCsv }>Download CSV For Google</Button> */}
						<QueryLimitChanger limit={this.state.limit} onChangeQueryLimit={this.handleChangeQueryLimit} />

						<Row style={{ marginTop: 16 }}>
							<Col>
								<Card title="Keywords" bodyStyle={{ padding: "16px 24px" }}>

									{this.state.keywords.length === 0 && this.state.loading && (
										"Loading..."
									)}

									{this.state.keywords.length === 0 && !this.state.loading && (
										<div style={{ color: "rgba(0,0,0,0.45)" }}>
											Search something
										</div>
									)}

									{this.state.keywords.map((keyword) => {
										return (
											<div>
												{keyword.word} ({keyword.count})
											</div>
										);

									})}

								</Card>
							</Col>
						</Row>


					</Col>
				</Row>

				<Row style={{ padding: "0px 16px 16px 16px" }}>
					<Table
						loading={this.state.loading}
						rowKey="_id"
						style={{ background: 'white' }}
						dataSource={this.state.fromProducts}
						columns={columns}
						size="middle"
						rowSelection={{
							onChange: this.handleOnChangeRowSelection,
							selectedRowKeys: this.state.selectedProducts
							// getCheckboxProps: record => ({
							// 	disabled: record.name === 'Disabled User', // Column configuration not to be checked
							// 	name: record.name,
							// }),
						}}
						pagination={false}
					/>
				</Row>

				<Modal
					title="Confirm Transfer"
					visible={this.state.confirmModalOpen}
					okText="Transfer"
					onCancel={() => this.toggleModalVisible(false)}
					onOk={() => this.handleTransferProducts()}
				>

					{
						this.state.to.unit !== "active" && [
							<p>Transfer {this.state.selectedProducts.length} products from old <strong>{this.state.to.unit}</strong> to new <strong>{this.state.to.unit}</strong>: </p>,
							<p><strong>{this.state.to.label && this.state.to.label.map(v => `/${v}`)}</strong></p>
						]
					}

					{
						this.state.to.unit === "active" && (
							<p>{this.state.to.value ? "Activate" : "De-Activate"} {this.state.selectedProducts.length} products?</p>
						)
					}




					{/* <Row justify="end" type="flex">
						<Col>
							<Button>Transfer</Button>
						</Col>
					</Row> */}

				</Modal>
			</div>
		);
	}

	state = defaultState;

	constructor(props) {
		super(props);

		this.searchProducts = debounce(this.searchProducts, 400);
		let query = this.extractQueryParams(this.props.location.search);

		if (query.massUploadId) {
			defaultState.massUploadId = query.massUploadId;

			this.setState({ massUploadId: query.massUploadId });
			this.searchProducts({});
			_getMassUploadBatch(this.state.massUploadId)
				.then(res => {
					this.setState({
						massUploadBatch: res.data
					});
				});
		}

		_getAllCategories()
			.then(res => {
				const categories = this.getSortedCategories(res.data.categories).map(
					c => ({
						label: c.title,
						value: c.titleUrl,
						children: c.children.map(
							_c => ({
								label: _c.title,
								value: _c.titleUrl
							})
						)
					})
				);

				defaultState.categories = categories;

				this.setState({ categories });
			});
	}

	/**
	 * @todo - to remove if server-side adds sorting.
	 */
	getSortedCategories(categories) {
		/**
		 * Sort Categories
		 */
		const sortedCategories = categories.sort((a, b) => {

			if (a.titleUrl > b.titleUrl) {
				return 1;
			} else {
				return - 1;
			}
		});
		/**
		 * Sort Sub Categories
		 */
		const sortedCategoriesFull = sortedCategories.map(category => {
			if (category.children && category.children.length !== 0) {
				category.children.sort((a, b) => {
					if (a.titleUrl > b.titleUrl) {
						return 1;
					} else {
						return - 1;
					}
				});
			}

			return category;
		});

		return sortedCategoriesFull;
	};

	extractQueryParams = (queryString) => {
		return queryString.replace('?', '').split('&').reduce(
			(acc, cur) => {

				const tmpSplit = cur.split('=');

				return {
					...acc,
					[tmpSplit[0]]: tmpSplit[1]
				};
			}, {}
		);
	};


	filter = (inputValue, path) => {
		return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
	};

	handleChangeQueryLimit = (limit) => {

		this.setState({ limit });

	};

	handleDeleteProducts = () => {
		const { selectedProducts } = this.state;

		if (selectedProducts.length === 0) {
			return message.error('Please tick a product!');
		}

		let loader = message.loading('Deleting Products...');
		// create 
		_postDeleteProducts({ selectedProducts })
			.then(res => {

				loader();

				message.success(`${selectedProducts.length} products deleted.`);

				this.resetToSelection();
				this.searchProducts(this.state.query);

			});

	};

	handleDownloadCsv = () => {

		message.loading("Preparing File...", 0);

		_postDownloadCsvForGoogle(this.state.selectedProducts)
			.then(res => {

				let blob = new File([res.data], "eezee-product.csv", { type: "text/csv" });

				let URL = window.URL || window.webkitURL;
				let downloadUrl = URL.createObjectURL(blob);

				message.destroy();

				window.location = downloadUrl;

				// setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100);

			});

	};

	handleOnChangeFrom = (value) => {

		this.setState({ from: value });

	};

	handleOnChangeRowSelection = (selectedRowKeys, selectedRows) => {
		this.setState({
			selectedProducts: selectedRowKeys
		});
		// console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
	};

	handleOnChangeToType = (value) => {

		this.setState({ toType: value });

		switch (value) {
			case "ACTIVATE":

				this.handleSelectTo({
					unit: 'active',
					value: true,
				});

				break;

			case "DEACTIVATE":

				this.handleSelectTo({
					unit: 'active',
					value: false,
				});

				break;
		}

	};

	handleOnChangebaseCurrency = (value) => {

		this.setState({ toType: value });

		switch (value) {
			case "ACTIVATE":

				this.handleSelectTo({
					unit: 'active',
					value: true,
				});

				break;

			case "DEACTIVATE":

				this.handleSelectTo({
					unit: 'active',
					value: false,
				});

				break;
		}

	};

	handleSelectFrom = ({ unit, value }) => {

		// _getProducts({

		// 	// { unit, value }

		// })

		// if( )
		// const {foo, ...state} = this.state;
		// this.setState({state});


		let q;

		switch (unit) {
			case "brand":

				q = { "brand.name": value };

				break;

			case "category":

				this.setState({
					fromCategory: value ? value : []
				});

				if (value && value["$ne"] === "") {
					q = { "categories.subKebabCase": { $ne: "" } };
				} else {
					q = { "categories.subKebabCase": value ? value[1] : value };
				}

				break;

			case "search":

				// if( value ){
				// 	q = {"title": value };
				// } else {
				// 	q = {"title": "" };
				// }
				q = { "title": value };

				break;

			case "supplierId":

				q = { "supplierId": value };

				break;

			case "supplierBrand":

				q = { "supplierBrand": value };

				break;

			case "active":

				q = { "active": value };

				break;

			case "baseCurrency":

				q = { "baseCurrency": value };

				break;

			case "enquiryType":

				q = { "enquiryType": value };

				break;

			default:
				break;
		}

		this.setState({
			loading: true,
			query: {
				...this.state.query,
				...q
			}
		}, () => {

			// console.log( this.state.query, Object.keys(this.state.query) );
			// // if(  )
			// // case "cancel":
			// // 	return this.setState( defaultState );
			// let actualQueries = [];

			// Object.keys(this.state.query).map(
			// 	key => {
			// 		if( this.state.query[key] !== null ){
			// 			actualQueries.push(true);
			// 		}
			// 	}
			// )		

			// if( actualQueries.length > 0 ){
			this.searchProducts(this.state.query);
			// }

		});

	};

	handleSelectTo = ({ label, unit, value }) => {
		this.setState({
			to: { label, unit, value }
		});
	};

	handleTransferProducts = () => {

		const { selectedProducts, to } = this.state;

		// create 
		_postTransferProducts({ selectedProducts, to })
			.then(res => {


				this.resetToSelection();
				this.searchProducts(this.state.query);

			});

		// console.log(
		// 	selectedProducts,
		// 	to.unit,
		// 	to.value
		// )
	};


	resetToSelection = () => {
		this.setState({
			confirmModalOpen: false,
			toType: '',
			to: {
				unit: '',
				value: ''
			},
			selectedProducts: []
		});
	};

	toggleModalVisible = (open = true) => {

		if (open) {

			let errors = [];

			message.destroy();

			console.log({
				state: this.state
			})

			if (this.state.selectedProducts.length === 0) {
				errors.push('Please tick a product');
			}

			if ((!this.state.to.unit || !this.state.to.value) && this.state.to.value !== false) {
				errors.push('Please select an action');
			}

			if (errors.length > 0) {
				return errors.map(err => message.error(err));
			}


		}

		this.setState({
			confirmModalOpen: open
		});
	};

	removeFromQuery = ({ unit }) => {

		let query = {
			...this.state.query
		};

		switch (unit) {
			case "brand":

				delete query["brand.name"];

				break;

			case "category":

				delete query["categories.subKebabCase"];

				break;

			case "search":

				delete query["title"];

				break;

			case "supplierId":

				delete query["supplierId"];

				break;

			case "active":

				delete query["active"];

				break;

			default:
				break;
		}

		this.setState({
			loading: true,
			query
		}, () => {

			this.searchProducts(this.state.query);

		});

	};

	searchProducts = (query) => {

		// this.setState({

		// });

		let realQuery = {};

		Object.keys(query).map(
			key => {



				if (query[key] !== "undefined" && key !== "title") {
					realQuery[key] = query[key];
				}

				if (key === "title" && query[key]) {
					realQuery[key] = query[key];
				}

				return key;

			}
		);

		if (this.state.massUploadId) {
			realQuery["massUploadId"] = this.state.massUploadId;
		}

		if (Object.keys(realQuery).length === 0 && realQuery.constructor === Object) {
			return this.setState(defaultState);
		}

		_postSearchProducts(realQuery, this.state.limit)
			.then(res => {

				const fromProducts = res.data.products.map(product => {

					return {
						...product,
						approved: product.approved ? true : false
					};
				});

				this.setState({
					keywords: res.data.keywords,
					selectedProducts: [],
					fromProducts,
					loading: false
				});
			});
	};

	renderTag = (approved) => {
		switch (approved) {
			case true:
				return <Tag color="green">TRUE</Tag>;
			case false:
				return <Tag color="red">FALSE</Tag>;
			case null:
				return '-';
			default:
				return '-';
		}
	};

}

class QueryLimitChanger extends React.PureComponent {

	render() {
		return (
			<Input addonBefore="Query Limit:" type="number" onChange={this.handleChangeQueryLimit} defaultValue={this.props.limit} />
		);
	}

	constructor(props) {

		super(props);

		this.state = {
			limit: props.limit
		};

		this.handleChangeParentLimit = debounce(this.handleChangeParentLimit, 400);

	}

	handleChangeQueryLimit = (e) => {
		this.handleChangeParentLimit(e.target.value);
	};

	handleChangeParentLimit = (limit) => {
		this.props.onChangeQueryLimit(limit);
	};

}

export default withRouter(TransferProducts);


// WEBPACK FOOTER //
// ./src/components/product/transfer/index.js